<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">申诉类型</span>
      </div>
    </div>

    <div class="content-header">
      <div class="left"></div>
      <div class="right">
        <Button type="primary" @click="openModal()">新增</Button>
      </div>
    </div>

    <Table size="small" :columns="columns" :data="data" :loading="loading" />

    <Modal width="460" :title="modal.data.id ? '编辑申诉类型' : '新增申诉类型'" v-model="modal.visible">
      <Form :label-width="100">
        <FormItem label="合作伙伴:" v-if="!agent.tp">
          <Select
            v-model="modal.data.agent_id"
            filterable
            remote
            clearable
            :remote-method="searchAgent"
            :loading="agentSearch.loading"
            placeholder="请选择合作伙伴"
          >
            <Option v-for="item in agentSearch.list" :value="item.id" :key="item.id">{{ item.agent_name || item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="类型名称:">
          <Input v-model.trim="modal.data.name" placeholder="请输入类型名称" />
        </FormItem>
        <FormItem label="排序:">
          <InputNumber
            :active-change="false"
            :min="0"
            :precision="0"
            style="width: 160px"
            v-model="modal.data.sort"
          />
        </FormItem>
        <FormItem label="状态:">
          <Select v-model="modal.data.is_del" style="width: 160px">
            <Option :value="0">正常</Option>
            <Option :value="1">删除</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="modal.visible = false">取消</Button>
        <Button type="primary" :loading="modal.loading" @click="submit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  GetTmallAfterSaleTypes,
  SaveTmallAfterSaleType,
  DelTmallAfterSaleType
} from '@/api/tmall-after-sale'

export default {
  data () {
    return {
      loading: false,
      data: [],
      agentSearch: {
        loading: false,
        list: []
      },
      modal: {
        visible: false,
        loading: false,
        data: {
          id: '',
          agent_id: '',
          name: '',
          sort: 0,
          is_del: 0
        }
      },
      columns: [
        { width: 90, key: 'id', title: '类型ID' },
        { minWidth: 180, key: 'name', title: '类型名称' },
        { width: 100, key: 'sort', title: '排序' },
        {
          width: 100,
          key: 'is_del',
          title: '状态',
          render: (h, params) => h('span', Number(params.row.is_del) === 1 ? '已删除' : '正常')
        },
        {
          width: 160,
          key: 'agent_name',
          title: '合作伙伴',
          tooltip: true,
          render: (h, params) => h('span', params.row.agent_name || params.row.agentName || '-')
        },
        {
          width: 160,
          key: 'operator',
          title: '操作',
          render: (h, params) => {
            const children = [
              h('Button', {
                props: { size: 'small', type: 'warning' },
                style: { marginRight: '6px' },
                on: { click: () => this.openModal(params.row) }
              }, '编辑')
            ]
            if (Number(params.row.is_del) !== 1) {
              children.push(h('Button', {
                props: { size: 'small', type: 'error' },
                on: { click: () => this.deleteType(params.row) }
              }, '删除'))
            }
            return h('div', children)
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      agent: 'agent'
    })
  },
  mounted () {
    if (this.agent.tp && Number(this.agent.is_tmall) !== 1) {
      this.$Message.error('无权访问天猫售后模块')
      this.$router.replace({ name: 'error_401' })
      return
    }
    this.getData()
  },
  methods: {
    ...mapActions(['getAgentList']),
    searchAgent (query) {
      if (!query) return
      this.agentSearch.loading = true
      this.getAgentList({ cond: 'agent_name', value: query, is_del: 0, p: 0, l: 100 }).then(res => {
        this.agentSearch.loading = false
        this.agentSearch.list = res && res.data ? res.data : []
      }).catch(() => {
        this.agentSearch.loading = false
      })
    },
    getData () {
      this.loading = true
      GetTmallAfterSaleTypes().then(res => {
        this.loading = false
        const result = res.data
        if (!result || !result.status) {
          this.$Message.error((result && result.msg) || '获取申诉类型失败')
          return
        }
        this.data = result.data || []
      }).catch(() => {
        this.loading = false
        this.$Message.error('获取申诉类型失败')
      })
    },
    openModal (row) {
      const data = row ? JSON.parse(JSON.stringify(row)) : {}
      this.modal = {
        visible: true,
        loading: false,
        data: {
          id: data.id || '',
          agent_id: data.agent_id || data.agentId || '',
          name: data.name || '',
          sort: Number(data.sort || 0),
          is_del: Number(data.is_del || 0)
        }
      }
      if (!this.agent.tp && this.modal.data.agent_id) {
        const exists = this.agentSearch.list.some(item => Number(item.id) === Number(this.modal.data.agent_id))
        if (!exists && (data.agent_name || data.agentName)) {
          this.agentSearch.list.push({
            id: this.modal.data.agent_id,
            agent_name: data.agent_name || data.agentName
          })
        }
      }
    },
    submit () {
      if (!this.modal.data.name) {
        this.$Message.error('请输入类型名称')
        return
      }
      if (!this.agent.tp && !this.modal.data.agent_id) {
        this.$Message.error('请选择合作伙伴')
        return
      }
      const data = JSON.parse(JSON.stringify(this.modal.data))
      if (!data.id) delete data.id
      if (this.agent.tp) delete data.agent_id
      this.modal.loading = true
      SaveTmallAfterSaleType(data).then(res => {
        this.modal.loading = false
        const result = res.data
        if (!result || !result.status) {
          this.$Message.error((result && result.msg) || '保存申诉类型失败')
          return
        }
        this.$Message.success((result && result.msg) || '保存成功')
        this.modal.visible = false
        this.getData()
      }).catch(() => {
        this.modal.loading = false
        this.$Message.error('保存申诉类型失败')
      })
    },
    deleteType (row) {
      this.$Modal.confirm({
        title: '删除申诉类型',
        content: `确认删除“${row.name}”？`,
        onOk: () => {
          DelTmallAfterSaleType({ id: row.id }).then(res => {
            const result = res.data
            if (!result || !result.status) {
              this.$Message.error((result && result.msg) || '删除申诉类型失败')
              return
            }
            this.$Message.success((result && result.msg) || '删除成功')
            this.getData()
          }).catch(() => {
            this.$Message.error('删除申诉类型失败')
          })
        }
      })
    }
  }
}
</script>
